import React, { JSX, useState } from "react";
import { ResultCategory } from "../../common/components/search/ResultCategory";
import { useLocalData } from "../../common/hooks/useLocalData";
import { MoonLoader, Searchbar } from "@hatch-digital-nl/bravilor-storybook";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearResults, performSearch } from "./SearchPageSlice";

const SearchPageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { products, getLocalImageUrl } = useLocalData();
    const {
        machinery,
        accessories,
        resultInputValue,
        resultCount,
        isLoading,
        productImages,
    } = useAppSelector((state) => state.search);

    const [typingTimeout, setTypingTimeout] = useState<
        number | ReturnType<typeof setTimeout>
    >(0);

    const searchHandler = (
        event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        const target = event.target as HTMLInputElement;

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        if (!target.value || target.value === "") {
            dispatch(clearResults());
            return;
        }

        setTypingTimeout(
            setTimeout(function () {
                dispatch(
                    performSearch({
                        products,
                        searchValue: target.value,
                        getLocalImageUrl,
                    }),
                );
            }, 1000),
        );
    };

    return (
        <div className="p-search">
            <div className="p-search__header">
                <div className="c-searchbar">
                    <Searchbar
                        autofocus={true}
                        placeholderTekst={
                            "Search for machines or accessories by name or article number"
                        }
                        onChange={searchHandler}
                    />
                </div>
            </div>

            {!isLoading ? (
                <div className="p-search__content">
                    <div className="p-search__content__header">
                        <h2>
                            {resultCount} result{resultCount !== 1 ? "s" : ""}{" "}
                            for &apos;<u>{resultInputValue}</u>&apos;
                        </h2>
                    </div>

                    <div className="p-search__content__results-container">
                        <ResultCategory
                            products={machinery}
                            category={"Machines"}
                            resultCount={machinery.length}
                            productImages={productImages}
                        />
                        <ResultCategory
                            products={accessories}
                            category={"Accessories"}
                            resultCount={accessories.length}
                            productImages={productImages}
                        />
                    </div>
                </div>
            ) : (
                <div className={"c-loader"}>
                    <MoonLoader color={"#E52713FF"} />
                </div>
            )}
        </div>
    );
};

export default SearchPageContainer;
